
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/transportbil",
      function () {
        return require("private-next-pages/tyres/transportbil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/transportbil"])
      });
    }
  